import en from './strings.en';

const ru = {
    noData: 'Попробуйте изменить\nили сбросить настройки фильтра'
};

export default { ru, en: { ...ru, ...en} };
